import { FETCH_DATA_WISHLISTS_PROFILE } from "../ActionType/actionTypes";
import axios from "axios";
import base64Sign from "../../function/base64Sign";
import { getToken } from "../../utils/setSessionUser";
import {BaseURL} from '../../function/helpers'
import { isLoadingWishlist } from "./Loading/isLoadingWishlistActions";

export const fetchWishLists = (url) => {
    return( dispatch ) => {
        const signature = base64Sign(url);
        const access_token = getToken();
        const headers = 
        {
        'Content-Type':'application/json',
        'sign' : signature,
        'access_token' : access_token
        }
        axios.post(BaseURL + url,
            {data: ""},
            {headers : headers}
        )
            .then( data => {
                dispatch({
                    type: FETCH_DATA_WISHLISTS_PROFILE,
                    payload: {
                        wishLists: data.data.response_data.results.ListWishlist
                    }
                })
                dispatch(isLoadingWishlist(false))
            } )
            .catch(error => {
                console.log(error);
            })
    }
}